import { Icon } from "@/react/components/shared/Icon";
import { Typography } from "@circle-react-shared/uikit/Typography";

export const LinkCard = ({ title, url }: { title: string; url: string }) => (
  <button
    type="button"
    onClick={() => {
      if (url.startsWith("http") || url.startsWith("https")) {
        window.location.href = url;
      } else {
        window.location.href = window.location.origin + url;
      }
    }}
    className="border-primary flex w-[368px] items-start gap-2 rounded-2xl border px-4 py-3"
  >
    <Icon type="copilot-chain-link" size={20} />
    <Typography.LabelSm weight="medium">{title}</Typography.LabelSm>
  </button>
);
